import React, { Dispatch, SetStateAction } from 'react';
import moment from 'moment';
import { DateFormats } from 'constants/common';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { AccessTime, Cancel, CheckCircle, Edit, InfoOutlined, Warning } from '@mui/icons-material';

import { ReportsListingViewModel } from '../../../types';

interface Props {
  row: ReportsListingViewModel;
  setViewMode: Dispatch<SetStateAction<{ viewType: 'view' | 'edit'; submitMode: 'closeDate' | 'estimatedCloseDate' }>>;
}

export const View = ({ setViewMode, row }: Props) => {
  if (!row.closeDate && !row.estimatedCloseDate) {
    return (
      <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
        <Stack direction="row" gap="0.5rem" alignItems="center">
          <Tooltip arrow placement="top" title="Estimated close date">
            <InfoOutlined color="disabled" />
          </Tooltip>

          <Typography color="textDisabled">Set estimated date</Typography>
        </Stack>

        <IconButton size="small" onClick={() => setViewMode({ viewType: 'edit', submitMode: 'estimatedCloseDate' })}>
          <Edit fontSize="small" />
        </IconButton>
      </Stack>
    );
  }

  if (row.closeDate) {
    return (
      <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
        <Stack direction="row" gap="0.5rem" alignItems="center">
          {row.closeStatus === 'SUCCESS' && (
            <Tooltip arrow placement="top" title="Won">
              <CheckCircle color="success" />
            </Tooltip>
          )}

          {row.closeStatus === 'FAILED' && (
            <Tooltip arrow placement="top" title="Lost">
              <Cancel color="warning" />
            </Tooltip>
          )}

          <Typography color={row.closeStatus === 'SUCCESS' ? 'green' : 'warning'}>
            {moment(row.closeDate).format(DateFormats.DayShortMonthYear)}
          </Typography>
        </Stack>

        <IconButton size="small" onClick={() => setViewMode({ viewType: 'edit', submitMode: 'closeDate' })}>
          <Edit fontSize="small" />
        </IconButton>
      </Stack>
    );
  }

  if (row.estimatedCloseDate) {
    return (
      <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
        {!!row.overdueInDays ? (
          <Stack direction="row" gap="0.5rem" alignItems="center">
            <Tooltip arrow placement="top" title={`Overdue ${row.overdueInDays} days`}>
              <Warning color="error" />
            </Tooltip>

            <Typography color={!!row.overdueInDays ? 'error' : 'textPrimary'}>
              {moment(row.estimatedCloseDate).format(DateFormats.DayShortMonthYear)}
            </Typography>
          </Stack>
        ) : (
          <Stack direction="row" gap="0.5rem" alignItems="center">
            <Tooltip arrow placement="top" title="Expected close date">
              <AccessTime />
            </Tooltip>

            <Typography>{moment(row.estimatedCloseDate).format(DateFormats.DayShortMonthYear)}</Typography>
          </Stack>
        )}

        <IconButton size="small" onClick={() => setViewMode({ viewType: 'edit', submitMode: 'estimatedCloseDate' })}>
          <Edit fontSize="small" />
        </IconButton>
      </Stack>
    );
  }

  return null;
};
